import { connect } from 'react-redux';
import { get } from 'lodash';
import { INITIAL_BOOKING_ROOT_KEY } from '../../constants';
import { START_SIGN_IN_STRINGS, signInEndpoint } from './constants';
import { paths } from '../../paths';
import {
    getDoctorCardPropsFromInitialBookingState,
    pushWithQuery,
    wrapWithDispatch,
} from '../../utils';
import { startLUXPageTransition } from '../../utils/LUXUtils';
import SignInPageView from './view';
import {
    triggerUserTypeChange,
    StartSignInPageActionCreators,
} from './actions';
import {
    showGoogleLoginButtonValue,
    showFacebookLoginButtonValue,
    showAppleLoginButtonValue,
} from './selector';

import { showRememberMeSelector } from '../../../config/ab/selector';

import * as Actions from '../../components/BookingContainer/BookingContainerActions';
import * as SchedulingActions from '../../actions/SchedulingActions';
import { getReferrerType } from '../../utils/getReferrerType';
import buildSsoReturnUrl from '../../utils/buildSsoReturnUrl';
import dispatchPageLoadTime from '../../../config/dispatchPageLoadTime';

const isWindowInIframe = () => {
    if (typeof window === 'undefined') {
        return false;
    }

    try {
        return window.self !== window.top;
    } catch (e) {
        // Browsers can block access to window.top due to same origin policy.
        return true;
    }
};

export const mapStateToProps = (state, ownProps) => {
    const bookingPage = state[INITIAL_BOOKING_ROOT_KEY];

    const forgotPasswordLinkTarget = '_self';
    const bookingId = get(ownProps, 'params.bookingId', '');

    // google and fb logins do not work in iframes due to x-frame-options restrictions. So hide them.
    const isInIframe = isWindowInIframe();

    return {
        facebookLoginUrl: bookingPage.facebookLoginUrl,
        forgotPasswordLinkTarget,
        googleLoginUrl: bookingPage.googleLoginUrl,
        appleLoginUrl: bookingPage.appleLoginUrl,
        isPatient: bookingPage ? bookingPage.isPatient : true,
        responseBody: state.signInForm.responseBody,
        returnUrl: buildSsoReturnUrl(bookingId, getReferrerType()),
        showFacebookLoginButton:
            showFacebookLoginButtonValue(state) && !isInIframe,
        showGoogleLoginButton: showGoogleLoginButtonValue(state) && !isInIframe,
        showAppleLoginButton: showAppleLoginButtonValue(state) && !isInIframe,
        showRememberMe: showRememberMeSelector(state),
        signedIn: state.signInForm.signedIn,
        signInEndpoint,
        ...getDoctorCardPropsFromInitialBookingState(state),
    };
};

export const mapDispatchToProps = (dispatch, ownProps) => ({
    dispatchPageLoadTime: component =>
        dispatch(dispatchPageLoadTime(component)),
    getBookingState: (bookingId, forceFetch) => {
        dispatch(SchedulingActions.getBookingState(bookingId, forceFetch));
    },
    onClickCreateAccount: () => {
        startLUXPageTransition();
        dispatch(
            pushWithQuery(
                `${paths.createAccountPath}/${ownProps.params.bookingId}`
            )
        );
    },
    onSignInSuccess: response => {
        dispatch(triggerUserTypeChange(response));
        startLUXPageTransition();
        dispatch(
            pushWithQuery(
                `${paths.reviewAndBookPath}/${ownProps.params.bookingId}`
            )
        );
    },
    triggerNotAPatient: () => {
        dispatch(
            Actions.showModal({
                headerText:
                    START_SIGN_IN_STRINGS.OopsOnlyPatientsCanBookAppointments,
                descriptionText: START_SIGN_IN_STRINGS.PleaseSignInAsAPatient,
                onClickPrimaryButton: () => {
                    dispatch(Actions.hideModal());
                },
            })
        );
    },
    ...wrapWithDispatch(StartSignInPageActionCreators, dispatch),
});

export const StartSignInPageConnector = connect(
    mapStateToProps,
    mapDispatchToProps
)(SignInPageView);
